import React from 'react';
import '../pages-styles/home.css';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import PlayersGrid from '../components/PlayersGrid';

function Home() {
  usePageMeta(
    'Professional Football Agency & Consultancy | Magbity Agency Ltd',
    'Magbity Agency Ltd is a leading football agency offering player representation, club services, and professional football business consultancy. Search for football agents and sports management solutions.'
  );
  return (
    <div className="home-page">
      
      {/* Hero Section */}
      <section className="hero-section" style={{ backgroundImage: `url(/home.jpg)` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-copy">
            <h1>We Match Players with the Right Partners</h1>
            <p className="hero-subtitle">Expert project consultancy — representation, transfers, and strategic partnerships for players and clubs.</p>

            <div className="hero-cta">
              <Link to="/football-agency" className="cta-btn primary">Football Agency</Link>
              <Link to="/contact" className="cta-btn tertiary">Book a Call</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="intro-section">
        <h2>MAGBITY AGENCY LTD</h2>
        <p>Magbity Agency Ltd is a professional consultancy firm providing market research, project planning, project management, ICT consultancy, and monitoring & evaluation services. We support NGOs, government institutions, businesses, and development partners to design, implement, and evaluate sustainable and high-impact projects.</p>
        <p>We provides professional football representation alongside structured football-related project consultancy.</p>
        <p>We work with integrity, transparency, and a long-term approach to football careers and football development projects.</p>
      </section>

      {/* Players Grid Section */}
      <PlayersGrid />

    </div>
  );
}

export default Home;
